import React, {useState} from 'react';
import useSWR from "swr";
import {getHttpClient, swrFetcher} from "@/utils/api.ts";
import {AssetResponseItem} from "@/@types/AssetTypes.ts";
import {RenderPost} from "@/pages/posts/PostsHome.tsx";
import {FiCalendar, FiCheck, FiFacebook, FiInstagram, FiSave} from "react-icons/fi";
import {Link, useLocation, useParams, useSearchParams} from "wouter";
import Button from "@/components/form/Button.tsx";
import Drawer from "@/components/Drawer.tsx";
import {closeDrawer, openDrawer} from "@/components/dispatch_functions.ts";
import {FaFacebook} from "react-icons/fa6";
import RenderPlatformIcon from "@/components/RenderPlatformIcon.tsx";
import Input from "@/components/form/Input.tsx";
import {useDebounce} from "@uidotdev/usehooks";
import Spinner from "@/components/spinner.tsx";

interface PageResponse {
    assets: Array<AssetResponseItem & {saved_id?: number}>
    count: number
    page: number
    limit: number
}
function TabLink({kwd, title}){
    const [params] = useSearchParams();
    const search = params.get('search')
    return    <Link to={`?search=${kwd}`} role="tab" className={`tab ${kwd === search ? 'tab-active' : ''}`}>{title}</Link>
}

function Discover() {
    const [params] = useSearchParams();
    const search = params.get('search')
    const [searchFilter, setSearchFilter] = useState('')
    const _debSearch = useDebounce(searchFilter, 500)
    const [selectedItem, setSelectedItem] = useState<AssetResponseItem | null>(null)
    const {data, isLoading} = useSWR<PageResponse>(`/assets/library?limit=100&page=0&search=${_debSearch || search || ''}`, swrFetcher)
    return (
        <div>
            <h1 className={"text-4xl mb-2"}>Discover</h1>
            <p>Re-postable stuff from across the web</p>
            <div className="mb-2">
                <Input type={"search"} value={searchFilter} onChange={setSearchFilter} />
            </div>
            {/*<div role="tablist" className="tabs tabs-bordered">*/}
            {/*    <TabLink title={"Trendy"} kwd={"trendy"}/>*/}
            {/*    <TabLink title={"Funny"} kwd={"funny"}/>*/}
            {/*    <TabLink title={"Cute"} kwd={"cute"}/>*/}
            {/*    <TabLink title={"Creative"} kwd={"creative"}/>*/}
            {/*    <TabLink title={"Travel"} kwd={"travel"}/>*/}
            {/*    <TabLink title={"Informative"} kwd={"information"}/>*/}
            {/*</div>*/}
          <ScheduleDrawer item={selectedItem} />
            {
                isLoading ? <div className="text-center"><Spinner/></div> : null
            }
            <div className="max-w-md mx-auto">
            {
                    data?.assets.map((i) => {
                        return <div className={"card mb-3 overflow-hidden rounded-xl border shadow-md border-base-200"}
                                    key={String(i.id)}>
                            <RenderPost post={i} key={i.id}/>
                            <div className="flex gap-2 py-2 px-2">
                                <SaveButton

                                    item={i} />
                                <button
                                    onClick={()=>{
                                        setSelectedItem(i)
                                        openDrawer(`schedule-post`)
                                    }}
                                    title={"Creates a new post from this asset"}
                                    className={"btn btn-ghost"}>
                                    <FiCalendar/> Schedule
                                </button>
                            </div>
                        </div>
                    })
                }
            </div>
            {/*<pre>{JSON.stringify(data, null, 2)}</pre>*/}
        </div>
    );
}

function ScheduleDrawer({item}: {item: AssetResponseItem}){
    const [, navigate] = useLocation()
    const schedule = (type: string)=>async ()=>{
        closeDrawer(`schedule-post`)
        const scheduleId = await getHttpClient().post(`/assets/duplicate`, {
            id: item.id,
            type
        }).then(({data})=>data.id)
        if(scheduleId) {
            navigate(`/posts/edit/${scheduleId}`)
        }
    }

    return   <Drawer position={"start"} title={"Schedule Post"} id={`schedule-post`}>
        <div className={"card rounded-xl m-1 border overflow-hidden border-base-200"}>
            {
                item ?
                <RenderPost post={item} /> : null
            }
        </div>
        <ul className="divide divide-y divide-base-200 rounded-xl border border-base-200">
            <div onClick={schedule('facebook-page-post')} className={"flex " +
                "px-3 hover:text-primary " +
                "gap-2 items-center py-3 cursor-pointer"}>
                <RenderPlatformIcon platform={"facebook"}/> Facebook
            </div>
            <div onClick={schedule('instagram-post')} className={"flex " +
                "px-3 hover:text-primary " +
                "gap-2 items-center py-3 cursor-pointer"}>
                <RenderPlatformIcon platform={"instagram"}/> Instagram
            </div>
            <div onClick={schedule('twitter-thread')} className={"flex " +
                "px-3 hover:text-primary " +
                "gap-2 items-center py-3 cursor-pointer"}>
                <RenderPlatformIcon platform={"twitter"}/> X (formerly Twitter)
            </div>
        </ul>
        <div className="flex flex-col gap-2 py-2 px-2">

        </div>
    </Drawer>
}

function SaveButton({item}:{item: AssetResponseItem & {saved_id?: number}}){
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(item.saved_id);
    const toggleSave = async ()=>{
        setSaving(true)
        if(saved){
            await getHttpClient().delete(`/assets/${saved}`)
            setSaved(null)
            setSaving(false)
        }else {
            const res = await getHttpClient().post('/assets/library/save', {
                id: item.id
            }).then(({data}) => data)
            setSaving(false)
            setSaved(res.id);
            return res.id;
        }
    }
    const [,navigate] = useLocation()

    return <>
        <button
            onClick={toggleSave}
            title={saved ? 'Click to remove' : 'Click to save'}
            className={`btn btn-ghost ${saved ? 'text-primary' : ''}`}>
            {
                saved ? <FiCheck/> :
                    <FiSave/>
            }
            {saving ? saved ? 'Removing...' : 'Saving...' : saved ? 'Saved' : 'Save'}</button>
    </>
}

export default Discover;
